module.exports = __webpack_public_path__ + "img/step2.b0cec161.svg";